<template>
  <DBox :id="'cmp-catalog-tracks-sidewindow-track_setup'" :addButton="false">
    <TextField2
      :disabled="selectedTrackDetails.disabled"
      :id="'artist'"
      :placeholder="$t('artist')"
      :label="$t('artist')"
      :value="selectedTrackDetails.track.artist"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedTrackDetails.disabled"
      :id="'title'"
      :placeholder="$t('title')"
      :label="$t('title')"
      :value="selectedTrackDetails.track.title"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedTrackDetails.disabled"
      :id="'version'"
      :placeholder="$t('version')"
      :label="$t('version')"
      :value="selectedTrackDetails.track.version"
      @blur="onTextFieldValueChange"
    />
    <div class="fc2 fc2-row ut-flex">
      <label class="fc2-label txtov">{{$t('product')}}</label>
      <div class="ut-flex">
        <div class="title-txt">
          <span
            @click="
              e => onProductSelected(selectedTrackDetails.product.product_id)
            "
            >{{
              selectedTrackDetails.product.catalog_no || $t('catalog_no')
            }}</span
          >
        </div>
        <div class="icon">
          <img
            @click="searchProductClick"
            class="dt-icon v6 h1 s1"
            src="static/icons/lupe.svg"
            alt
          />
        </div>
      </div>
    </div>
    <template v-if="isrcLength==1">
      <div class="ut-flex" style="border-bottom:1px solid var(--sprt-85);">
        <TextField2
           style="flex: 12;"
          :disabled="selectedTrackDetails.disabled"
          :id="'isrc'"
          :placeholder="$t('isrc')"
          :label="$t('isrc')"
          :value="selectedTrackDetails.track.isrc"
          @blur="onTextFieldValueChange"
          :bb="'0px'"
          
        />
        <div class="dt-icon-container" style="flex: 1;">
          <img
            src="static/icons/edit-blue.svg"
            class="dt-icon v5 s1"
            :alt="$t('options')"
            :title="$t('options')"
            @click="onClickISRC"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <TextField2
        :disabled="selectedTrackDetails.disabled"
        :id="'isrc'"
        :placeholder="$t('isrc')"
        :label="$t('isrc')"
        :value="selectedTrackDetails.track.isrc"
        @blur="onTextFieldValueChange"
        
      />
    </template>
    
    <Dropdown2
      :label="$t('type')"
      :placeholder="$t('type')"
      :disabled="selectedTrackDetails.disabled"
      :options="typesTV"
      :selected="typesTV.find(e => e.value == selectedTrackDetails.track.type)"
      v-on:selectedChange="e => onDropdownChange('type', e)"
    />
    <TextField2
      :disabled="selectedTrackDetails.disabled"
      :id="'playtime'"
      :placeholder="$t('play_time')"
      :label="$t('play_time')"
      :value="selectedTrackDetails.track.playtime"
      @blur="onTextFieldValueChange"
    />
    <Dropdown2
      :label="$t('country')"
      :placeholder="$t('country')"
      :disabled="selectedTrackDetails.disabled"
      :options="selectedTrackDetails.countriesTV"
      :selected="
        selectedTrackDetails.countriesTV.find(
          e => e.value == selectedTrackDetails.track.country
        )
      "
      v-on:selectedChange="e => onDropdownChange('country', e)"
    />
    <Dropdown2
      :label="$t('languages')"
      :placeholder="$t('languages')"
      :disabled="selectedTrackDetails.disabled"
      :options="selectedTrackDetails.languagesTV"
      :selected="
        selectedTrackDetails.languagesTV.find(
          e => e.value == selectedTrackDetails.track.language
        )
      "
      v-on:selectedChange="e => onDropdownChange('language', e)"
    />
    <Dropdown2
      :label="$t('digital_rights')"
      :placeholder="$t('digital_rights')"
      :disabled="selectedTrackDetails.disabled"
      :options="selectedTrackDetails.digitalRightTpyesTV"
      :selected="
        selectedTrackDetails.digitalRightTpyesTV.find(
          e => e.value == selectedTrackDetails.track.digital_right_type
        )
      "
      v-on:selectedChange="e => onDropdownChange('digital_right_type', e)"
    />
    <Checkbox2
      :disabled="selectedTrackDetails.disabled"
      :id="'explicit_flag'"
      :label="$t('explicit_lyrics')"
      :value="selectedTrackDetails.track.explicit_flag"
      :placeholder="$t('explicit_lyrics')"
      @input="onCheckboxChange"
    />
    <TextField2
      :disabled="selectedTrackDetails.disabled"
      :id="'p_year'"
      :placeholder="$t('p_year')"
      :label="$t('p_year')"
      :value="selectedTrackDetails.track.p_year"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedTrackDetails.disabled"
      :id="'p_line'"
      :placeholder="$t('p_line')"
      :label="$t('p_line')"
      :value="selectedTrackDetails.track.p_line"
      bb="0px"
      @blur="onTextFieldValueChange"
    />
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { TracksService } from "../../services/tracks.service";

export default {
  components: {
    DBox
  },
  props: ["selectedTrackDetails"],
  computed: {
    typesTV: function() {
      return [
        { text: "Audio", value: "audio" },
        { text: "Video", value: "video" },
        { text: "Mix", value: "mix" }
      ];
    },
    track_id:function(){
      return this.selectedTrackDetails?.track?.track_id; 
    },

    isrcLength:function(){
      return this.selectedTrackDetails?.track?.isrc?.length<12?1:0; 
    }
  },
  methods: {
    onTextFieldValueChange: function(event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, value) {
      this[name] = value.value;
      this.$emit("changed", { name, value: value.value });
    },
    onCheckboxChange: function({ name, value }) {
      this.$emit("changed", {
        name,
        value: value ? "1" : "0"
      });
    },
    searchProductClick: function() {
      this.$emit("add_click", true);
    },
    onProductSelected: function(selectedProductId) {
      this.$emit("selected_product", selectedProductId);
    },
    onClickISRC:async function(){
      await TracksService.autoIsrc(this.track_id);
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-tracks-sidewindow-track_setup {
  .fc2-row {
    --fc2-tf-padding: 0px 10px;
    --fc2-tf-margin: 3px 3px 3px 0px;
    --bb: 1px solid var(--sprt-85);

    height: 32px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }
  }
}
</style>
